import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useMediaQuery, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form-mui";
import { CustomSelectElement } from "../../layouts/Theme";
export default function AmountSelect({ min, max, required, label, value, setter, object, placeholder }) {
    const theme = useTheme();
    const isLarge = useMediaQuery(theme.breakpoints.up('sm'));
    const { setValue } = useFormContext();
    useEffect(() => {
        // value !== undefined, not the old `value &&` — 0 is a real, selectable amount, and the
        // truthy check silently dropped it, leaving this select stuck showing its placeholder
        // despite a real answer of 0 already in effect.
        if (value !== undefined && value !== null && !required) {
            if (max && value > max) {
                value = max;
            }
            if (setter)
                setter(value);
            setValue(object ? `amount-${object.id}` : 'amount', value);
        }
    }, [value]);
    const onChange = (value) => {
        if (setter)
            setter(value);
    };
    // the amount, or the prompt while there is no answer yet. 0 is a real, selectable answer, so
    // only a genuinely unset value (undefined/null, parsing to NaN) reads as unanswered — not 0.
    const renderSelectedValue = (selected) => {
        let amount = parseInt(`${selected}`);
        if (isNaN(amount)) {
            return (_jsx(Typography, { component: "span", sx: { color: theme.palette.text.secondary }, children: placeholder !== null && placeholder !== void 0 ? placeholder : '' }));
        }
        return _jsx(Typography, { component: "span", children: amount });
    };
    const options = [];
    // `??`, not a truthy check — a min of 0 is a real bound, and the truthy check silently
    // swapped it for 1, making 0 unselectable even though it is a valid amount.
    for (let i = (min !== null && min !== void 0 ? min : 1); i < (max ? max + 1 : 100); i++) {
        options.push({ id: i, label: i.toString() });
    }
    return (_jsx(_Fragment, { children: options.length > 1 && (_jsx(Box, { sx: { minWidth: 120, my: 1, maxWidth: isLarge ? '500px' : '100%' }, children: _jsx(CustomSelectElement, { id: object ? `amount-${object.id}` : 'amount', label: label !== null && label !== void 0 ? label : "Aantal", 
                // Neither `defaultValue` nor `value` actually drives what shows here:
                // CustomSelectElement (react-hook-form-mui's SelectElement) always
                // displays its own react-hook-form-registered value instead, set above
                // via setValue(). Passing `defaultValue` alongside that is a conflicting
                // pair MUI treats inconsistently for a falsy (0) value specifically.
                name: object ? `amount-${object.id}` : 'amount', onChange: onChange, options: options, 
                // the prompt occupies the value slot, so the label stays shrunk instead of
                // dropping on top of it
                InputLabelProps: { shrink: true }, SelectProps: {
                    // MUI skips renderValue while the field is empty unless it is told
                    // the empty state is worth rendering
                    displayEmpty: true,
                    renderValue: renderSelectedValue
                } }) })) }));
}
